import { PkButton, PkEmptyMessage, PkIcon } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useStatisticFilters } from '../../hooks/filters';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const EmptyMessage = () => {
  const t = useTranslateFn();
  const { resetFilters } = useStatisticFilters();

  const handleResetFilter = () => {
    resetFilters();
  };

  return (
    <PkEmptyMessage className={styles.empty}>
      <div slot='title'>{t('we_are_sorry')}</div>
      <div>{t('stat_noresult')}</div>
      <PkButton slot='action' onPkClick={handleResetFilter} appearance='text'>
        {t('stat_reset_filters')}
        <PkIcon name='navigation-chevron-right' color='interaction' />
      </PkButton>
    </PkEmptyMessage>
  );
};

export default memo(EmptyMessage);
